export { default } from 'react-simple-code-editor';